/* WeDev - Bundle Menu Builder controller (munier/qa)
 * Quantity editing per item, live price, list sync, 3-state CTA (main + sticky),
 * bundle-quantity aware cart sync, cancel (option A), sticky bar, external-change re-render.
 * Native fixed bundle: the bundle line quantity is the number of whole menus;
 * extra units above base are separate line items. Cart is synced with absolute
 * quantities via /cart/update (or /cart/add when the bundle is not yet in the cart).
 */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-wd-bundle-root]');
    if (!root) return;

    var bundleVariant = String(root.getAttribute('data-bundle-variant') || '');
    var bundlePrice = parseInt(root.getAttribute('data-bundle-price'), 10) || 0; // cents
    var compareAt = parseInt(root.getAttribute('data-bundle-compare-at'), 10) || 0; // cents
    var bundleTitle = root.getAttribute('data-bundle-title') || '';
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    var routes = (window.routes || (window.theme && window.theme.routes) || {});
    var addUrl = (routes.cart_add_url || '/cart/add');
    var updateUrl = (routes.cart_update_url || '/cart/update');
    var cartUrl = (routes.cart_url || '/cart');

    // ---- money ----
    function formatMoney(cents) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      function num(n, precision, thousands, decimal) {
        precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
        thousands = thousands == null ? ',' : thousands;
        decimal = decimal == null ? '.' : decimal;
        var number = (parseInt(cents, 10) || 0) / 100;
        var neg = number < 0 ? '-' : '';
        var base = parseInt(Math.abs(number).toFixed(precision), 10) + '';
        var mod = base.length > 3 ? base.length % 3 : 0;
        return neg + (mod ? base.substr(0, mod) + thousands : '') +
          base.substr(mod).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
          (precision ? decimal + Math.abs(number - base).toFixed(precision).slice(2) : '');
      }
      switch (moneyFormat.match(placeholderRegex) ? moneyFormat.match(placeholderRegex)[1] : 'amount') {
        case 'amount': value = num(2); break;
        case 'amount_no_decimals': value = num(0); break;
        case 'amount_with_comma_separator': value = num(2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = num(0, '.', ','); break;
        case 'amount_with_space_separator': value = num(2, ' ', '.'); break;
        case 'amount_no_decimals_with_space_separator': value = num(0, ' ', ''); break;
        case 'amount_with_apostrophe_separator': value = num(2, "'", '.'); break;
        default: value = num(2);
      }
      if (((parseInt(cents, 10) || 0) % 100) === 0) value = value.replace(/[.,]0+$/, '');
      return moneyFormat.replace(placeholderRegex, value);
    }

    // ---- items ----
    var items = [].slice.call(root.querySelectorAll('[data-wd-item]')).map(function (el) {
      var base = parseInt(el.getAttribute('data-base'), 10) || 1;
      var inputEl = el.querySelector('.wd-quantity-selector__input, input[name="quantity"]');
      var startQty = base;
      if (inputEl) {
        inputEl.min = base; // cannot go below the base quantity
        var iv = parseInt(inputEl.value, 10);
        startQty = (!isNaN(iv) && iv > base) ? iv : base;
        inputEl.value = startQty;
      }
      return {
        el: el,
        variant: String(el.getAttribute('data-variant') || ''),
        price: parseInt(el.getAttribute('data-price'), 10) || 0,
        base: base,
        qty: startQty,
        inputEl: inputEl,
        valEl: el.querySelector('.wd-quantity-selector__value'),
        minusEl: el.querySelector('.wd-quantity-selector__button--minus'),
        addedEl: el.querySelector('[data-wd-added]'),
        baseNoteEl: el.querySelector('.wd-qty-base-note')
      };
    });
    if (!items.length) return;

    // cart state: bundleQty = line quantity of the bundle in the cart (0 if absent)
    var cart = { bundleQty: 0, committed: {} };

    // ---- bundle quantity (number of whole menus) from the main quantity selector ----
    function bundleQtyInput() {
      return document.querySelector('.wd-product-form__quantity input[name="quantity"], .product-form__quantity input[name="quantity"], input.quantity__input-primary');
    }
    function desiredBundleQty() {
      var el = bundleQtyInput();
      var v = el ? parseInt(el.value, 10) : 1;
      return v > 0 ? v : 1;
    }
    function setBundleQtyInput(v) {
      var el = bundleQtyInput();
      if (el) { el.value = v; }
    }

    function committedOf(vv) { return cart.committed[vv] || 0; }
    function anyCommitted() { return Object.keys(cart.committed).some(function (v) { return cart.committed[v] > 0; }); }
    function anyPageExtra() { return items.some(function (it) { return it.qty > it.base; }); }
    function liveTotal() {
      var t = bundlePrice * desiredBundleQty();
      items.forEach(function (it) { t += (it.qty - it.base) * it.price; });
      return t;
    }
    function extraDeltaCents() {
      var t = 0;
      items.forEach(function (it) { var d = (it.qty - it.base) - committedOf(it.variant); if (d > 0) t += d * it.price; });
      return t;
    }
    function bundleQtyChanged() { return desiredBundleQty() !== cart.bundleQty; }
    function extrasChanged() { return items.some(function (it) { return (it.qty - it.base) !== committedOf(it.variant); }); }
    function anyDecrease() { return items.some(function (it) { return (it.qty - it.base) < committedOf(it.variant); }); }

    function ctaState() {
      if (cart.bundleQty === 0) {
        return anyPageExtra()
          ? { key: 'add-extras', label: 'הוסף לסל עם התוספות · ' + formatMoney(liveTotal()) }
          : { key: 'add-base', label: 'הוסף לסל · ' + formatMoney(liveTotal()) };
      }
      if (!bundleQtyChanged() && !extrasChanged()) {
        return { key: 'incart', label: '✓ התפריט בסל · מעבר לסל' };
      }
      if (!bundleQtyChanged() && extraDeltaCents() > 0 && !anyDecrease()) {
        return { key: 'add-delta', label: 'הוסף תוספות לסל · +' + formatMoney(extraDeltaCents()) };
      }
      return { key: 'update', label: 'עדכן סל · ' + formatMoney(liveTotal()) };
    }

    // ---- element collections ----
    function ctaButtons() { return [].slice.call(document.querySelectorAll('.wd-product-form__submit')); }
    function livePriceEls() { return [].slice.call(document.querySelectorAll('[data-wd-bundle-live-price]')); }
    function stickyPriceEls() { return [].slice.call(document.querySelectorAll('[id^="Price-Alt-"]')); }
    function listQtyEls() { return [].slice.call(document.querySelectorAll('[data-wd-list-qty]')); }
    function cancelEls() { return [].slice.call(document.querySelectorAll('.wd-bundle-cancel')); }

    function setPriceHTML(el, cents) { el.innerHTML = '<price-money><bdi>' + formatMoney(cents) + '</bdi></price-money>'; }

    // ---- inject cancel buttons next to each CTA button ----
    function ensureCancel(btn) {
      var wrap = btn.parentNode;
      if (!wrap || wrap.querySelector('.wd-bundle-cancel')) return;
      var c = document.createElement('button');
      c.type = 'button';
      c.className = 'wd-bundle-cancel';
      c.hidden = true;
      c.textContent = '↺ בטל שינויים בכמויות';
      c.addEventListener('click', function (e) { e.preventDefault(); doCancel(); });
      wrap.insertBefore(c, btn.nextSibling);
    }

    function bindCtaButtons() {
      ctaButtons().forEach(function (btn) {
        if (btn.getAttribute('data-wd-bound')) return;
        btn.setAttribute('data-wd-bound', '1');
        btn.type = 'button'; // stop native product-form submit
        btn.addEventListener('click', function (e) {
          if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
          e.preventDefault();
          doAdd();
        });
        ensureCancel(btn);
      });
    }

    function labelSpan(btn) { return btn.querySelector('span') || btn; }

    // read each grid item's quantity from the theme selector's input (source of truth),
    // clamp to the base minimum, and mirror it back to the input and the visible value
    function syncItemsFromInputs() {
      items.forEach(function (it) {
        if (!it.inputEl) return;
        var v = parseInt(it.inputEl.value, 10);
        if (isNaN(v)) v = it.base;
        if (v < it.base) v = it.base;
        it.qty = v;
        if (String(it.inputEl.value) !== String(v)) it.inputEl.value = v;
        if (it.valEl) it.valEl.textContent = v;
      });
    }

    function render() {
      syncItemsFromInputs();
      var lt = liveTotal();
      livePriceEls().forEach(function (el) { setPriceHTML(el, lt); });
      stickyPriceEls().forEach(function (el) { setPriceHTML(el, lt); });

      listQtyEls().forEach(function (sp) {
        var v = String(sp.getAttribute('data-wd-list-qty'));
        var it = items.filter(function (x) { return x.variant === v; })[0];
        if (it) { sp.textContent = it.qty; sp.classList.toggle('wd-qty-changed', it.qty > it.base); }
      });

      items.forEach(function (it) {
        if (it.valEl) it.valEl.textContent = it.qty;
        if (it.minusEl) it.minusEl.disabled = it.qty <= it.base;
        // base-quantity note shows only after the shopper edits this item's quantity
        if (it.baseNoteEl) it.baseNoteEl.hidden = !(it.qty > it.base);
        var c = committedOf(it.variant);
        if (it.addedEl) {
          if (c > 0) { it.addedEl.hidden = false; it.addedEl.textContent = '✓ ' + c + ' תוספות בסל'; }
          else it.addedEl.hidden = true;
        }
      });

      var st = ctaState();
      ctaButtons().forEach(function (btn) {
        labelSpan(btn).textContent = st.label;
        btn.classList.remove('wd-cta--incart', 'wd-cta--delta', 'wd-cta--update');
        if (st.key === 'incart') btn.classList.add('wd-cta--incart');
        if (st.key === 'add-delta') btn.classList.add('wd-cta--delta');
        if (st.key === 'update') btn.classList.add('wd-cta--update');
        btn.setAttribute('data-wd-state', st.key);
      });

      // show the cancel button only when the user actually changed quantities
      var showCancel = anyPageExtra() || anyCommitted() || desiredBundleQty() > 1;
      cancelEls().forEach(function (c) { c.hidden = !showCancel; });
      syncCancelWidths();
    }

    // keep the cancel button the same width as its add-to-cart button
    function syncCancelWidths() {
      cancelEls().forEach(function (c) {
        if (c.hidden) return;
        var sub = c.parentNode && c.parentNode.querySelector('.wd-product-form__submit');
        if (sub) c.style.width = Math.round(sub.getBoundingClientRect().width) + 'px';
      });
    }

    // ---- cart ops ----
    function sectionsToRender() {
      var mc = document.querySelector('mini-cart');
      if (mc && mc.getSectionsToRender) return mc.getSectionsToRender().map(function (s) { return s.id; });
      return ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
    }
    function renderMiniCart(state) {
      var mc = document.querySelector('mini-cart');
      if (mc && mc.renderContents) { try { mc.renderContents(state); } catch (e) { } }
    }
    function refreshCartState() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          cart.bundleQty = 0;
          cart.committed = {};
          (data.items || []).forEach(function (li) {
            var vid = String(li.variant_id || li.id);
            if (vid === bundleVariant) { cart.bundleQty += li.quantity; return; }
            var isExtra = items.some(function (it) { return it.variant === vid; });
            if (isExtra) cart.committed[vid] = (cart.committed[vid] || 0) + li.quantity;
          });
        })
        .catch(function () { });
    }

    function postCart(url, payload) {
      return fetch(url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json(); });
    }

    function openCart() {
      var mc = document.querySelector('mini-cart');
      if (mc && mc.open) { try { mc.open(); return; } catch (e) { } }
      window.location = cartUrl;
    }

    var busy = false;
    function setBusy(b) {
      busy = b;
      ctaButtons().forEach(function (btn) { btn.classList.toggle('loading', b); });
    }

    // line item property that links every extra unit to its parent menu, so the
    // extras are identifiable in the cart and in the order (and merge into one line)
    function extraProps() { return { 'תוספת לתפריט': bundleTitle }; }

    function doAdd() {
      if (busy) return;
      var st = ctaState();
      if (st.key === 'incart') { openCart(); return; }
      setBusy(true);
      var sections = sectionsToRender();
      var p;
      if (cart.bundleQty === 0) {
        // not in cart yet: add bundle (with chosen quantity) + extra deltas (linked to the menu)
        var addItems = [{ id: bundleVariant, quantity: desiredBundleQty() }];
        items.forEach(function (it) { var need = it.qty - it.base; if (need > 0) addItems.push({ id: it.variant, quantity: need, properties: extraProps() }); });
        p = postCart(addUrl, { items: addItems, sections: sections, sections_url: window.location.pathname });
      } else if (st.key === 'add-delta') {
        // bundle already in cart, purely additive extras: ADD the deltas with the link
        // property so they merge into the existing linked lines (update.js can't set properties)
        var addItems2 = [];
        items.forEach(function (it) { var need = (it.qty - it.base) - committedOf(it.variant); if (need > 0) addItems2.push({ id: it.variant, quantity: need, properties: extraProps() }); });
        p = postCart(addUrl, { items: addItems2, sections: sections, sections_url: window.location.pathname });
      } else {
        // already in cart with a bundle-quantity change and/or decreases: set absolute quantities
        var updates = {};
        updates[bundleVariant] = desiredBundleQty();
        items.forEach(function (it) { updates[it.variant] = (it.qty - it.base); });
        p = postCart(updateUrl, { updates: updates, sections: sections, sections_url: window.location.pathname });
      }
      p.then(function (resp) {
        if (resp && resp.status && resp.status !== 200) { return; }
        renderMiniCart(resp);
        return refreshCartState();
      }).catch(function () { }).finally(function () { setBusy(false); render(); });
    }

    function doCancel() {
      if (busy) return;
      // reset every grid item back to its base quantity — including the theme
      // selector's own input/value, otherwise syncItemsFromInputs re-reads the old value
      items.forEach(function (it) {
        it.qty = it.base;
        if (it.inputEl) it.inputEl.value = it.base;
        if (it.valEl) it.valEl.textContent = it.base;
      });
      setBundleQtyInput(1);
      if (cart.bundleQty > 0) {
        setBusy(true);
        var updates = {};
        updates[bundleVariant] = 1; // keep one base menu
        items.forEach(function (it) { updates[it.variant] = 0; }); // remove extras
        postCart(updateUrl, { updates: updates, sections: sectionsToRender(), sections_url: window.location.pathname })
          .then(function (resp) { renderMiniCart(resp); return refreshCartState(); })
          .catch(function () { }).finally(function () { setBusy(false); render(); });
      } else {
        render();
      }
    }

    // ---- grid item quantity changes (theme quantity selector) -> re-render ----
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.wd-quantity-selector__button')) setTimeout(render, 0);
    });
    root.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.wd-quantity-selector__input, input[name="quantity"]')) render();
    });
    root.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('.wd-quantity-selector__input, input[name="quantity"]')) render();
    });

    // ---- bundle quantity input change -> re-render ----
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[name="quantity"]')) render();
    });
    document.addEventListener('click', function (e) {
      // theme quantity stepper buttons (plus/minus) update the input async; re-render shortly after
      if (e.target && e.target.closest && e.target.closest('.wd-product-form__quantity, .product-form__quantity')) {
        setTimeout(render, 0);
      }
    });

    // ---- sticky bar visibility ----
    var docRoot = document.documentElement;
    function stickyBarHeight() {
      var sb = document.querySelector('.product-sticky-cart');
      var h = sb ? Math.round(sb.getBoundingClientRect().height) : 0;
      return h > 0 ? h : 86;
    }
    // lift any bottom-left floating buttons (e.g. the WhatsApp float) above the sticky
    // add-to-cart bar so they never sit on top of the add-to-cart button on mobile
    function setStickyFloatOffset(shown) {
      docRoot.style.setProperty('--wd-wa-sticky', shown ? (stickyBarHeight() + 12) + 'px' : '0px');
    }
    var stickyWrap = document.querySelector('animate-sticky.sticky-cart-wrapper') || document.querySelector('.sticky-cart-wrapper');
    var mainBtn = ctaButtons().filter(function (b) { return !stickyWrap || !stickyWrap.contains(b); })[0] || ctaButtons()[0];
    if (stickyWrap && mainBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          // toggle the theme's native reveal attribute (works on mobile and desktop)
          if (en.isIntersecting) { stickyWrap.removeAttribute('animate'); setStickyFloatOffset(false); }
          else { stickyWrap.setAttribute('animate', ''); setStickyFloatOffset(true); }
        });
      }, { threshold: 0 });
      io.observe(mainBtn);
    }

    // ---- enhance main section (price-block conditional, live price host, mobile H1 / title->H2) ----
    function enhanceMain() {
      var pc = document.querySelector('.bundle-price-container');
      if (pc) {
        var host = pc.children[0] ? pc.children[0].querySelector('.price') : null;
        if (host) host.setAttribute('data-wd-bundle-live-price', '');
        if (!(compareAt && compareAt > bundlePrice) && pc.children[1]) {
          pc.children[1].style.display = 'none';
        }
      }
      var titleH = document.querySelector('.product__title .product__heading') || document.querySelector('h1.product__heading');
      if (titleH && titleH.tagName === 'H1') {
        var h2 = document.createElement('h2');
        for (var i = 0; i < titleH.attributes.length; i++) { h2.setAttribute(titleH.attributes[i].name, titleH.attributes[i].value); }
        h2.innerHTML = titleH.innerHTML;
        titleH.parentNode.replaceChild(h2, titleH);
      }
      var media = document.querySelector('.product__media-wrapper');
      if (media && bundleTitle && !media.querySelector('.wd-bundle-mobile-title')) {
        var mh1 = document.createElement('h1');
        mh1.className = 'wd-bundle-mobile-title';
        mh1.textContent = bundleTitle;
        media.insertBefore(mh1, media.firstChild);
      }
    }

    // ---- external cart changes (remove / edit in the drawer or cart page) -> re-render ----
    function externalRefresh() {
      var before = cart.bundleQty;
      refreshCartState().then(function () {
        // if the whole menu was removed from the cart, remove its linked extras too
        // (only on an observed present->absent transition, never on the initial load,
        // so a component the shopper added on its own is left untouched)
        if (before > 0 && cart.bundleQty === 0 && anyCommitted()) {
          var updates = {};
          items.forEach(function (it) { if (committedOf(it.variant) > 0) updates[it.variant] = 0; });
          return postCart(updateUrl, { updates: updates, sections: sectionsToRender(), sections_url: window.location.pathname })
            .then(function (resp) { renderMiniCart(resp); return refreshCartState(); });
        }
      }).then(render).catch(function () { render(); });
    }
    if (typeof window.subscribe === 'function') {
      try { window.subscribe('cart-update', externalRefresh); } catch (e) { }
      try { window.subscribe('quantity-update', externalRefresh); } catch (e) { }
    }
    document.addEventListener('cartdrawer:opened', externalRefresh);
    document.addEventListener('wd-cartdrawer:opened', externalRefresh);
    window.addEventListener('focus', externalRefresh);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) externalRefresh(); });
    window.addEventListener('resize', function () { syncCancelWidths(); });

    // ---- boot ----
    enhanceMain();
    bindCtaButtons();
    render();
    refreshCartState().then(render);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
